// Redux
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
// Reducers
// Routing
import createHistory from "history/createBrowserHistory";
import { routerMiddleware } from "react-router-redux";
import reducers from "./combinedReducers";

export const history = createHistory();
history.listen((location, action) => {
  window.scrollTo(0, 0);
});

const middleware = () => composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk));

const store = createStore(reducers, middleware());

export default store;
